module.exports = __webpack_public_path__ + "static/bk-2-77d6d3a9f8423de579a157a442ec9305.png";